import React from 'react';
import { Spinner } from 'react-bootstrap';

function LoadingSpinner({size}) {
  return (
    <div style={{ display: 'block'}}> 
      {/* <Spinner animation="border" variant="primary" /> */}
      <Spinner style={{height : size}} animation="grow" variant="primary" /> 
    </div> 
  );
}

export const LoadingBorder = ({variant}) => {
  return(
    <>
      <div style={{ display: 'block' }}>
        <Spinner animation="border" variant={variant} />
      </div> 
    </>
  );
}

export default LoadingSpinner;
